import EventService from '../../../helpers/classes/EventService';
import { ExceptionManager } from '../../../helpers/classes/ExceptionManager';
import LanguageService from '../../../helpers/classes/LanguageService';
import RenderingService from '../../../helpers/classes/RenderingService';
import TemplateService from '../../../helpers/classes/TemplateService';
import { JourneyContainer } from '../../classes/JourneyContainer';
import JourneyManager from '../../classes/JourneyManager';
import { JourneyEvent } from '../../enums/JourneyEvent';
import { Templates } from '../../enums/Templates';
import { TranslationKey } from '../../enums/Translation';

export class LoginStep {
	public static render(this: JourneyContainer) {
		return TemplateService.renderToContainer(this._container, Templates.Login)
			.then((element) => TemplateService.getElements(element, {
				password: '[data-jcs-element="login__password"]',
				form: '[data-jcs-element="login__form"]',
				submit: '[data-jcs-element="login__submit"]',
				username: '[data-jcs-element="login__username"]',
				errors: '[data-jcs-element="login__errors"]',
			}))
			.then(({ submit, username, password, errors, form }) => {
				if (form instanceof HTMLFormElement && submit instanceof HTMLInputElement && username instanceof HTMLInputElement && password instanceof HTMLInputElement) {
					form.addEventListener('submit', (e) => {
						e.preventDefault();

						this.clearJourney()
							.then(() => RenderingService.setText(errors))
							.then(() => RenderingService.setEnabled(submit, false))
							.then(() => JourneyManager.login({
								area: 'scanning',
								password: password.value,
								username: username.value
							}))
							.catch(LoginStep.renderErrors.bind(this))
							.then(() => RenderingService.setEnabled(submit, true));
					});
					return Promise.resolve();
				} else {
					return Promise.reject(new ExceptionManager.TemplateException(TranslationKey.EXCEPTION_TEMPLATE_ELEMENTS_MISSING));
				}
			})
			.then(() => EventService.publish(JourneyEvent.DISPLAY_STEP, { step: Templates.Login }));
	}

	private static renderErrors(this: JourneyContainer, error: ExceptionManager.Exception) {
		TemplateService.getElements(this._container, {
			errors: '[data-jcs-element="login__errors"]',
		}).then(({ errors }) => {
			RenderingService.setText(errors, LanguageService.getTranslation(error.message as TranslationKey));
		});
	}
}
